/**
 * 英文文案词典（U2 §5.2 / D5 —— i18n 全量文案）
 *  - 扁平 key，与 zh.ts 一一对应
 */
export const en: Record<string, string> = {
  // 通用
  'app.name': 'ZhiHui',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.copy': 'Copy',
  'common.download': 'Download',
  'common.refresh': 'Refresh',
  'common.loading': 'Loading…',
  'common.empty': 'Nothing here',

  // 顶栏 / 导航
  'nav.conversations': 'ZhiHui',
  'nav.user': 'User Center',
  'nav.invites': 'Invite Codes',
  'nav.chat': 'Chat',
  'nav.menu': 'Open menu',
  'ai.joined': 'ZhiHui joined',

  // AI 模式
  'ai.mode.quiet': 'Quiet',
  'ai.mode.partner': 'Co-pilot',
  'ai.mode.host': 'Host',
  'ai.mode.desc.quiet': 'ZhiHui only responds when @mentioned',
  'ai.mode.desc.partner': 'ZhiHui proactively suggests',
  'ai.mode.desc.host': 'ZhiHui actively drives the discussion',
  'chat.context': '{n} ctx msgs',

  // 成果面板（ArtifactPanel）
  'artifacts.title': 'Structured Artifacts',
  'artifacts.new': 'New',
  'artifacts.empty': 'No artifacts yet.',
  'artifacts.emptyHint': 'Click “+” on a message to capture discussion as issue / solution / decision / action.',
  'artifacts.confirm': 'Confirm',
  'artifacts.export': 'Export',
  'artifacts.section.pending': 'Pending',
  'artifacts.section.issue': 'Issue',
  'artifacts.section.solution': 'Solution',
  'artifacts.section.decision': 'Decision',
  'artifacts.section.action': 'Action',
  'artifacts.panel': 'Artifacts',
  'artifacts.source': 'Source',
  'artifacts.aiGenerate': 'AI Generate',
  'artifacts.generating': 'Generating…',
  'artifacts.generated': 'Generated {n} artifacts',
  'artifacts.generateEmpty': 'No new artifact generated',
  'artifacts.generateFailed': 'Generation failed',
  'artifacts.generateInstruction': 'What should ZhiHui produce?',
  'artifacts.generatePlaceholder': 'e.g. Turn the latest discussion into decisions and next actions',
  'artifacts.generateHint': 'ZhiHui will use project memory and recent chat history. Decisions/actions still require human confirmation.',
  'artifactSkill.label': 'Built-in Skill',
  'artifactSkill.meeting': 'Meeting capture',
  'artifactSkill.meetingDesc': 'Create issues, decisions, and actions together.',
  'artifactSkill.issue': 'Extract issue',
  'artifactSkill.issueDesc': 'Extract questions, blockers, and open questions.',
  'artifactSkill.solution': 'Shape solution',
  'artifactSkill.solutionDesc': 'Organize options, pros, cons, risks, and recommendation.',
  'artifactSkill.decision': 'Capture decision',
  'artifactSkill.decisionDesc': 'Create a pending decision.',
  'artifactSkill.action': 'Break into action',
  'artifactSkill.actionDesc': 'Create task, owner, due date, and done criteria.',

  // 成果类型 / 状态
  'artifact.issue': 'Issue',
  'artifact.solution': 'Solution',
  'artifact.decision': 'Decision',
  'artifact.action': 'Action',
  'artifact.state.draft': 'Draft',
  'artifact.state.pending': 'Pending',
  'artifact.state.confirmed': 'Confirmed',
  'issue.status.in_progress': 'In progress',
  'issue.status.blocked': 'Blocked',
  'issue.status.resolved': 'Resolved',

  // 会话列表（ConversationListPage）
  'list.newGroup': 'New group',
  'list.newDm': 'New chat',
  'list.aiEntry': 'Talk to ZhiHui',
  'list.search': 'Search conversations or messages',
  'list.group': 'Groups',
  'list.dm': 'Chats',
  'list.emptyGroup': 'No groups yet',
  'list.emptyDm': 'No chats yet',
  'list.searching': 'Searching…',
  'list.searchResult': 'Results ({n})',
  'list.searchEmpty': 'No matching conversations or messages',
  'list.pin': 'Pin',
  'list.unpin': 'Unpin',
  'list.preview.noMessage': 'No messages',
  'list.preview.aiJoined': 'ZhiHui joined',
  'list.preview.aiNotJoined': 'ZhiHui not invited',
  'dialog.groupName': 'Group name',
  'dialog.peerAccount': 'Peer account',
  'dialog.peerHint': 'Enter exact account',
  'dialog.groupEmpty': 'Enter a group name',
  'dialog.dmEmpty': 'Enter peer account',

  // 聊天页（ChatPage）
  'chat.manageMembers': 'Members ({n})',
  'chat.inviteAi': 'Invite ZhiHui',
  'chat.inviting': 'Inviting…',
  'chat.loadOlder': 'Load earlier messages',
  'chat.searchPlaceholder': 'Search messages',
  'chat.notExists': 'Conversation not found',
  'chat.backToList': 'Back to list',
  'chat.aiDmHint': 'Chatting with ZhiHui: every message is sent, no @ needed',
  'chat.dmHint': 'DMs don’t trigger ZhiHui',
  'chat.manageTitle': 'Manage members',
  'chat.currentMembers': 'Current members ({n})',
  'chat.memberRole.owner': 'Owner',
  'chat.memberRole.ai': 'ZhiHui AI',
  'chat.memberRole.member': 'Member',
  'chat.addMember': 'Add member (registered account)',
  'chat.add': 'Add',

  // 语言切换
  'lang.label': 'Language',
  'lang.zh': '中文',
  'lang.en': 'English',

  // 模板（TemplatePicker）
  'template.title': 'Choose a template',
  'template.subtitle': 'A template sets the AI mode & artifact skeleton',
  'template.stdProduct': 'Standard Product Iteration',
  'template.research': 'Research & Survey',
  'template.content': 'Content Creation',
  'template.start': 'Start',
  'template.skip': 'No template',
  'template.aiMode': 'AI mode',

  // 项目记忆（MemoryPanel）
  'memory.title': 'Project Memory',
  'memory.add': 'Add memory',
  'memory.placeholder': 'Note a project memory…',
  'memory.save': 'Save',
  'memory.edit': 'Edit',
  'memory.delete': 'Delete',
  'memory.empty': 'No memories yet',
  'memory.emptyHint': 'Note key decisions / constraints / context; ZhiHui will use them in chat',
  'memory.source.manual': 'Manual',
  'memory.source.auto': 'Auto',
  'memory.contextHint': 'Injected into context (latest {n})',
  'memory.count': '{n} memories',
  'memory.updated': 'Memory updated',
  'memory.deleted': 'Memory deleted',
  'memory.added': 'Memory added',
  'memory.contentRequired': 'Memory content required',
  'memory.notFound': 'Memory not found',
  'memory.autoGenerate': 'AI Extract',
  'memory.autoGenerating': 'Extracting…',
  'memory.autoGenerated': 'Extracted {n} memories',
  'memory.autoEmpty': 'No new project memory extracted',
  'memory.autoFailed': 'AI extraction failed',

  // 周摘要（WeeklySummaryDialog）
  'weekly.title': 'Weekly Digest',
  'weekly.generate': 'Generate',
  'weekly.generating': 'Generating…',
  'weekly.empty': 'Nothing to summarize this week',
  'weekly.history': 'Past digests ({n})',
  'weekly.aiMissing': 'AI not configured; cannot generate weekly digest',
  'weekly.error': 'Failed: {msg}',

  // 分享卡片（ShareCardDialog）
  'share.title': 'Share Card',
  'share.generate': 'Generate Card',
  'share.preview': 'Preview',
  'share.option.summary': 'Conversation summary',
  'share.option.artifacts': 'Structured artifacts',
  'share.option.weekly': 'Weekly digest',
  'share.hint': 'Choose what to share',

  // 反馈
  'feedback.localeSwitched': 'Language switched',
};

